export default {
    en: {
        currencyFormat: {
            style: "currency",
            currency: "USD"
        },
        decimal: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        customFormat: {
            minimumIntegerDigits: 1, // Minimum tam sayı basamak sayısı
            minimumFractionDigits: 0, // Minimum ondalık basamak sayısı
            maximumFractionDigits: 2, // Maximum ondalık basamak sayısı
            useGrouping: true // Gruplama (binlik ayırıcı) kullanılsın mı?
        }
    },
    tr: {
        currencyFormat: {
            style: "currency",
            currency: "RUB"
        },
        decimal: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        customFormat: {
            minimumIntegerDigits: 1, // Minimum tam sayı basamak sayısı
            minimumFractionDigits: 0, // Minimum ondalık basamak sayısı
            maximumFractionDigits: 2, // Maximum ondalık basamak sayısı
            useGrouping: true // Gruplama (binlik ayırıcı) kullanılsın mı?
        }

    }
}